// Generated by ReScript, PLEASE EDIT WITH CARE


function execute(payload) {
  return {
          geo_region_id: payload.geo_region_id,
          vehicle_id: payload.vehicle_id,
          zone_ids: payload.zone_ids,
          cluster_ids: payload.cluster_ids,
          campaign_name: payload.campaign_name,
          effective_from: payload.effective_from,
          effective_till: payload.effective_till,
          _type: payload._type,
          sub_type: payload.sub_type,
          values: {
            auto: payload.values.auto,
            manual: payload.values.manual,
            threshold: payload.values.threshold,
            ratio: payload.values.ratio
          },
          days_of_week: payload.days_of_week,
          day_start_hour: payload.day_start_hour,
          day_start_min: payload.day_start_min,
          day_end_hour: payload.day_end_hour,
          day_end_min: payload.day_end_min
        };
}

export {
  execute ,
  
}
/* No side effect */
